<template>
    <div class="input__wrapper">
        <span class="input-label" :id="data.labelId">{{ data.label }}<span class="input__wrapper-mandatory" v-if="data.mandatoryFiled">*</span></span>
        <label class="switch switch-flat">
            <input
                class="switch-input"
                type="checkbox"
                v-model="inputVal"
                :id="data.inputId"
            />
            <span class="switch-label" data-on="Yes" data-off="No"></span>
            <span class="switch-handle"></span>
        </label>
    </div>
</template>

<script>
export default {
	props: {
		data: {
			type: Object,
			required: true
		}
	},
	data () {
		return {
			inputVal: this.value
		};
	},
	watch: {
		inputVal (val) {
			this.$emit('input', val);
		}
	},
	methods: {
		setValue(value) {
			this.inputVal = value;
		}
	}
};
</script>

<style lang="scss" scoped>
	.input__wrapper {
		display: flex;
		align-items: center;
	}
	.input-label {
		min-width: 50px;
        width: auto;
		display: inline-block;
		margin: 0;
        margin-right: 20px;

         @include mq(1440px) {
            margin-right: 15px;
        }

        @include mq($lg) {
            min-width: 170px;
        }

        @include mq($sm) {
            min-width: 140px;
        }
	}

    .switch {
        position: relative;
        display: block;
        min-width: 100px;
		max-width: 100px;
        height: 25px;
        margin: 0;
        background: $white;
        border-radius: 18px;
        cursor: pointer;
    }
    .switch-input {
        position: absolute;
        top: 0;
        left: 0;
        opacity: 0;
    }
    .switch-label {
        position: relative;
        display: block;
        height: inherit;
        font-size: 10px;
        text-transform: uppercase;
        background: $white-lilac;
        border-radius: inherit;
        box-sizing: border-box;
        border: 2px solid $white-lilac;
    }
    .switch-label:before, .switch-label:after {
        position: absolute;
        top: 50%;
        margin-top: -.5em;
        line-height: 1;
        transition: inherit;
    }
    .switch-label:before {
        content: attr(data-off);
        right: 11px;
        color: #aaaaaa;
        text-shadow: 0 1px rgba($white, .5);
    }
    .switch-label:after {
        content: attr(data-on);
        left: 11px;
        color: $fiord;
        text-shadow: 0 1px rgba($black, .2);
        opacity: 0;
    }
    .switch-input:checked ~ .switch-label {
		background: $white;
		border-color: $fiord;
    }
    .switch-input:checked ~ .switch-label:before {
        opacity: 0;
    }
    .switch-input:checked ~ .switch-label:after {
        opacity: 1;
    }
    .switch-handle {
        position: absolute;
        border-radius: 100%;
        top: 4px;
        left: 6px;
        background: #dadada;
        width: 17px;
        height: 17px;
        box-shadow: none;
    }
    .switch-handle:before {
        content: "";
        position: absolute;
        top: 50%;
        left: 53%;
        margin: -6px 0 0 -6px;
        width: 11px;
        height: 11px;
		background: #eceeef;
        border-radius: 6px;
        box-shadow: inset 0 1px rgba($black, .02);
    }
    .switch-input:checked ~ .switch-handle {
        left: 76px;
        background: $fiord;
    }

    .switch-label, .switch-handle {
        transition: All 0.3s ease;
    }
</style>
